import { RouteConfig } from 'vue-router/types/router';

// import { UserRight, HasRight } from '@/tools/rights';

import Allocations from '@/views/allocations.vue';

const BORDER_COLOR_BLUE = '#7CA6EF';
export interface IExtendedRouteConfig {
    displayName?: string;
    display?: boolean;
}

export type IRoute = RouteConfig & IExtendedRouteConfig;

export const routeDefinition: IRoute[] = [
    // {
    //     path: '/',
    //     name: 'root',
    //     redirect: {
    //         name: 'allocations',
    //     },
    // },
    {
        path: '/',
        name: 'allocations',
        component: Allocations,
    },
];
